<h3 class="ui header" i18n="@@articles-sort-title">Sortiert nach: </h3>
<div class="grouped fields">
  <div class="field">
    <sui-radio-button name="sortBy" value="updatedAt_desc" [(ngModel)]="sortBy" (ngModelChange)="valueChanged()" i18n="@@articles-creation-date-descending">
      Erstellungsdatum (absteigend - neueste zuerst)
    </sui-radio-button>
  </div>
  <div class="field">
    <sui-radio-button name="sortBy" value="updatedAt_asc" [(ngModel)]="sortBy" (ngModelChange)="valueChanged()" i18n="@@articles-creation-date-ascending">
      Erstellungsdatum (aufsteigend - älteste zuerst)
    </sui-radio-button>
  </div>
  <div class="field">
    <sui-radio-button name="sortBy" value="deadline_desc" [(ngModel)]="sortBy" (ngModelChange)="valueChanged()" i18n="@@articles-deadlines-descending">
      Fristen (absteigend)
    </sui-radio-button>
  </div>
  <div class="field">
    <sui-radio-button name="sortBy" value="deadline_asc" [(ngModel)]="sortBy" (ngModelChange)="valueChanged()" i18n="@@articles-deadlines-ascending">
      Fristen (aufsteigend - Ablaufende zuerst)
    </sui-radio-button>
  </div>
  <div class="field">
    <sui-radio-button name="sortBy" value="A-Z" [(ngModel)]="sortBy" (ngModelChange)="valueChanged()">
      A - Z, a - z
    </sui-radio-button>
  </div>
  <div class="field">
    <sui-radio-button name="sortBy" value="Z-A" [(ngModel)]="sortBy" (ngModelChange)="valueChanged()">
      z - a, Z - A
    </sui-radio-button>
  </div>
</div>
